import React, { useState } from 'react';
const STORAGE_KEY = 'hsg-cookies-accepted';
export function CookieBanner() {
  const [visible, setVisible] = useState(() => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) !== 'true';
    } catch {
      return true;
    }
  });
  const accept = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'true');
    } catch {
      // Speicher nicht verfügbar – Banner wird trotzdem geschlossen
    }
    setVisible(false);
  };
  if (!visible) return null;
  return <div role="region" aria-label="Cookie-Hinweis" style={{
    position: 'fixed'
  }} className="gold-shimmer inset-x-0 bottom-0 z-[100] flex flex-row items-center justify-center gap-3 border-t border-gold/40 bg-cream px-4 py-2.5 text-left shadow-[0_-4px_20px_rgba(0,0,0,0.08)] sm:gap-6 sm:py-4 sm:text-center" data-id="element-202" data-mp="13b3txrpgmeo3">
      <p className="text-[13px] font-medium leading-snug text-neutral-900 sm:text-sm" data-id="element-203" data-mp="pat2onk8my2e">
        Diese Website verwendet Cookies, um dir ein besseres Erlebnis zu bieten.
      </p>
      <button type="button" onClick={accept} className="btn-gold-shiny shrink-0 rounded-full px-5 py-2 text-[13px] font-semibold sm:px-6 sm:py-2.5 sm:text-sm" data-id="element-204" data-mp="xuraz77ftqg6">
        Okay
      </button>
    </div>;
}